import * as React from "react";
import Svg, { G, Path, Defs, ClipPath, Rect } from "react-native-svg";

function SvgComponent(props: any) {
  return (
    <Svg
      width={33}
      height={33}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_1_3668)">
        <Path
          d="M7.78813 8.712V12.54H7.26012C5.41212 12.54 3.82812 14.124 3.82812 15.972V29.7C3.82812 31.548 5.28012 33.132 7.26012 33.132H25.7401C27.5881 33.132 29.1721 31.548 29.1721 29.7V15.972C29.1721 14.124 27.7201 12.54 25.7401 12.54H25.2121V8.712C25.2121 3.828 21.2521 0 16.5001 0C11.7481 0 7.78813 3.96 7.78813 8.712ZM20.7241 25.08C21.2521 25.608 21.2521 26.4 20.7241 26.928C20.1961 27.456 19.4041 27.456 18.8761 26.928L16.6321 24.552L14.2561 26.928C13.7281 27.456 12.9361 27.456 12.4081 26.928C11.8801 26.4 11.8801 25.608 12.2761 25.08L14.5201 22.836L12.2761 20.46C11.7481 19.932 11.7481 19.14 12.2761 18.612C12.8041 18.084 13.5961 18.084 14.1241 18.612L16.5001 20.988L18.7441 18.612C19.2721 18.084 20.0641 18.084 20.5921 18.612C21.1201 19.14 21.1201 19.932 20.5921 20.46L18.3481 22.836L20.7241 25.08ZM10.4281 8.712C10.4281 5.412 13.2001 2.64 16.5001 2.64C19.8001 2.64 22.5721 5.412 22.5721 8.712V12.54H10.4281V8.712Z"
          fill="#D63C8A"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_1_3668">
          <Rect width={33} height={33} fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
